import { render } from "./FinalSalaryAssetsViewer.vue?vue&type=template&id=21a07b65&ts=true"
import script from "./FinalSalaryAssetsViewer.vue?vue&type=script&lang=ts"
export * from "./FinalSalaryAssetsViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__